import { Button, Typography } from '@material-ui/core';
import { useStyles } from '../MissingInfoDialog.styles';
import { HiOutlineArrowRight } from 'react-icons/hi';
import { GrStatusInfo } from 'react-icons/gr';
import { useHistory } from 'react-router-dom';
interface Props {
  mediaLength: {
    image: number;
    video: number;
    audio: number;
  };
  creditsCount: number;
  skillsCount: number;
  mediamessage: string[];
}

const StepTwo: React.FC<Props> = ({ mediaLength, creditsCount, skillsCount, mediamessage }) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={classes.missingInfos}>
      {(mediaLength.image <= 3 || mediaLength.video <= 3 || mediaLength.audio <= 3) && (
        <div className={classes.section}>
          <Typography className={classes.sectionTitle}>Media</Typography>
          <div className={classes.infoContainer}>
            <div className={`${classes.info} warning`}>
              <GrStatusInfo className={`${classes.infoIcon} warning`} />
              Only {mediamessage.join(', ')}
            </div>
            <Button
              type="button"
              variant="outlined"
              color="primary"
              disableElevation
              className={classes.redirectBtn}
              onClick={() => history.push('/talent/media/dashboard')}
            >
              Add Media Now <HiOutlineArrowRight style={{ marginLeft: 10, width: 20, height: 20 }} />
            </Button>
            <div className={`${classes.info} full-col`}>
              <GrStatusInfo className={classes.infoIcon} />
              All media uploaded to date and in the next 30 Days, will always remain on your profile Free of charge as
              part of our temporary Special Unlimited Media Offer.
            </div>
          </div>
        </div>
      )}

      {creditsCount <= 3 && (
        <div className={classes.section}>
          <Typography className={classes.sectionTitle}>Resume</Typography>
          <div className={classes.infoContainer}>
            <div className={`${classes.info} warning`}>
              <GrStatusInfo className={`${classes.infoIcon} warning`} />
              {creditsCount > 0 ? `Only ${creditsCount} Experiences listed` : 'Currently listed as No Experience'}
            </div>
            <Button
              type="button"
              variant="outlined"
              color="primary"
              disableElevation
              className={classes.redirectBtn}
              onClick={() => history.push('/talent/my_info/resume')}
            >
              Add Experience Now <HiOutlineArrowRight style={{ marginLeft: 10, width: 20, height: 20 }} />
            </Button>
          </div>
        </div>
      )}

      {skillsCount <= 3 && (
        <div className={`${classes.section} no-border`}>
          <Typography className={classes.sectionTitle}>Skills</Typography>
          <div className={classes.infoContainer}>
            <div className={`${classes.info} warning`}>
              <GrStatusInfo className={`${classes.infoIcon} warning`} />
              {skillsCount > 0 ? `Only ${skillsCount} Skills listed` : 'Currently No Skills Listed'}
            </div>
            <Button
              type="button"
              variant="outlined"
              color="primary"
              disableElevation
              className={classes.redirectBtn}
              onClick={() => history.push('/talent/my_info/skills')}
            >
              Add my Skills Now <HiOutlineArrowRight style={{ marginLeft: 10, width: 20, height: 20 }} />
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default StepTwo;
